import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FeedbackService } from '@app/core/services';
import { LoadSavedReportFiltersComponent } from '../load-report-filter/load-saved-report-filters.component';
import { SaveReportFiltersComponent } from '../save-report-filter/save-report-filters.component';
import { SavedReportFilterService } from '../services/saved-report-filter.service';
import { SavedReportFilterUserSelectionComponent } from '../user-selection/user-selection.component';

@Component({
    selector: 'saved-report-filter-buttons',
    templateUrl: './saved-report-filter-buttons.component.html',
    styleUrls: ['./saved-report-filter-buttons.component.less'],
    standalone: true,
    imports: [MatCardModule, MatToolbarModule],
})
export class SavedReportFilterButtonsComponent {
	@Input() reportType: number;
	@Input() filters: any[];
	@Input() buildReportFilters: (savedFilters: any[], model: any) => any[];
	@Input() filterData: any;
	@Output() filtersLoaded = new EventEmitter<string>();
	@Input() disableSave = false;
	@Input() allowBulkSaveReportFilters = false;

	userList: any[] = [];
	filterList: [] = [];
	constructor(
		private readonly dialog: MatDialog,
		private readonly service: SavedReportFilterService,
		private readonly feedbackService: FeedbackService
	) {}
	loadReportFilters(): void {
		this.service.getSavedReportFilters(this.reportType).subscribe((data) => {
			if (data.isValid) {
				const dialogRef = this.dialog.open(LoadSavedReportFiltersComponent, {
					width: '900px',
					data: {
						filters: data.data,
						reportType: this.reportType,
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result) {
						this.filtersLoaded.emit(result);
						this.feedbackService.success('loaded', 'Report Filters', { isPlural: true });
					}
				});
			}
		});
	}

	saveReportFilters(): void {
		this.filters = this.buildReportFilters(this.filters, this.filterData);

		// handles allowing bulk selection of users
		if (this.allowBulkSaveReportFilters) {
			this.dialog
				.open(SavedReportFilterUserSelectionComponent, {
					width: '900px',
					minWidth: '900px',
				})
				.afterClosed()
				.subscribe((userIds) => {
					if (!userIds) {
						return;
					}
					this.dialog.open(SaveReportFiltersComponent, {
						minWidth: '600px',
						data: {
							ReportTypeId: this.reportType,
							Filters: this.filters,
							UserIds: userIds,
						},
					});
				});
		} else {
			this.dialog.open(SaveReportFiltersComponent, {
				minWidth: '600px',
				data: {
					ReportTypeId: this.reportType,
					Filters: this.filters,
				},
			});
		}
	}
}
